import React from 'react';
import { IconStyled, IconStylesProps } from './IconStyles';

export const Download = ({ size = 'base', className = '' }: Partial<IconStylesProps>) => (
  <IconStyled
    size={size}
    className={className}
    viewBox="-5 0 32 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <g fill="none" fillRule="evenodd">
      <path d="M0 0L16 0 16 16 0 16z" />
      <path fill="currentColor" d="M17 12v5H3v-5H1v5a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-5z" />
      <path fill="currentColor" d="M10 15l5-6h-4V1H9v8H5l5 6z" />
    </g>
  </IconStyled>
);
